import { fg } from '@atlaskit/platform-feature-flags';

import { type PostOfficeContextConfig } from '../../post-office-context/types';

/**
 * There are certain conditions, eg. Baseline Criterion tests, where products want to disable all Post Office Placements.
 * NOT to be used in Prod.
 */
export const isPostOfficePlacementsGloballyDisabled = (
	context: PostOfficeContextConfig,
): boolean => {
	const isGlobalDisablePlacementCheckEnabled = fg('post-office-enable-disable-placement-check');

	if (isGlobalDisablePlacementCheckEnabled) {
		return context.disableAllPlacements === true;
	}

	return false;
};
